import "core-js/modules/es6.array.map";
import React from 'react';
import Image, { imageTypeProps } from '../Image/Image.component';
import withModifiers from '../../../_utils/withModifiers';

var ResponsiveImage = function ResponsiveImage(_ref) {
  var outputImage = _ref.outputImage,
      modifiers = _ref.modifiers,
      _ref$sources = _ref.sources,
      sources = _ref$sources === void 0 ? [] : _ref$sources,
      image = _ref.image;
  return /*#__PURE__*/React.createElement(React.Fragment, null, outputImage ? /*#__PURE__*/React.createElement(Image, {
    modifiers: modifiers,
    src: image.src,
    srcset: image.srcset,
    sizes: image.sizes,
    alt: image.alt,
    title: image.title
  }) : /*#__PURE__*/React.createElement("picture", {
    className: withModifiers('picture')(modifiers)
  }, sources.map(function (source) {
    return /*#__PURE__*/React.createElement("source", source);
  }), /*#__PURE__*/React.createElement(Image, {
    src: image.src,
    srcset: image.srcset,
    sizes: image.sizes,
    alt: image.alt,
    title: image.title
  })));
};

export default ResponsiveImage;